import { createFileRoute } from "@tanstack/react-router";
import { ArchivSeite } from "@/components/ArchivSeite";

/*
 * `/admin/archiv` — die archivierten Inventur-Läufe mit ZIP-Download.
 *
 * Der Unterstrich in `admin_.archiv.tsx` löst diese Route aus `admin.tsx`
 * heraus, genau wie bei `admin_.upload.tsx`: sie liegt PFADLICH unter `/admin`,
 * aber nicht in dessen Layout. Ohne ihn würde `admin.tsx` zur Layout-Route,
 * ihre Landeseite stünde über jeder Unterseite, und `/admin` bräuchte eine
 * zusätzliche Index-Route. Nachgesehen wird das am Generat (`fullPaths`), nicht
 * geraten.
 *
 * Kein `loader`: die Sicht erfragt Zugang und Daten in EINEM Aufruf und muss
 * 401, 403, den Lesefehler-als-Wert und den Leerzustand alle vier verschieden
 * beantworten — das gehört in die Komponente, die sie anzeigt.
 */
export const Route = createFileRoute("/admin_/archiv")({
  component: ArchivSeite,
});
